import React from 'react';
import { useStyletron } from 'baseui';
import { FormControl } from 'baseui/form-control';
import { Input } from 'baseui/input';
import { Button, KIND as ButtonKind } from 'baseui/button';
import { Modal, ModalHeader, ModalBody, ROLE } from 'baseui/modal';
import { CustomSelect } from './CustomSelect';
import { MethodTag } from './MethodTag';
import useStore from '../store';

export function EndpointForm({ endpoint, onSubmit, onCancel }) {
  const store = useStore();
  const [css] = useStyletron();
  const [formData, setFormData] = React.useState({
    name: '',
    description: '',
    projectId: 'default',
    method: 'GET',
    path: '',
    ...store.selectedEndpoint
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.id) {
      store.updateEndpoint(formData.id, formData);
    } else {
      store.createEndpoint(formData);
    }
    store.setSelectedEndpoint(null);
  };

  return (
    <Modal
      onClose={() => store.setSelectedEndpoint(null)}
      isOpen={!!store.selectedEndpoint}
      role={ROLE.dialog}
    >
      <ModalHeader>{formData.id ? 'Edit Endpoint' : 'Create Endpoint'}</ModalHeader>
      <ModalBody>
        <form 
          onSubmit={handleSubmit}
          className={css({
            backgroundColor: '#F8F9FA',
            paddingTop: '16px',
            paddingRight: '16px',
            paddingBottom: '16px',
            paddingLeft: '16px',
            borderTop: '1px solid #E2E8F0'
          })}
        >
          <div className={css({
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '1rem',
            marginBottom: '1rem'
          })}>
            <FormControl label="Name" caption="A descriptive name for the endpoint">
              <Input
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                placeholder="My API Endpoint"
              />
            </FormControl>

            <FormControl label="Description" caption="Optional description of the endpoint's purpose">
              <Input
                value={formData.description}
                onChange={e => setFormData({ ...formData, description: e.target.value })}
                placeholder="This endpoint is used for..."
              />
            </FormControl>

            <FormControl label="Method" caption="HTTP method for this endpoint">
              <CustomSelect
                options={[
                  { label: <MethodTag method="GET" />, id: 'GET' },
                  { label: <MethodTag method="POST" />, id: 'POST' },
                  { label: <MethodTag method="PUT" />, id: 'PUT' },
                  { label: <MethodTag method="DELETE" />, id: 'DELETE' },
                  { label: <MethodTag method="PATCH" />, id: 'PATCH' },
                ]}
                value={formData.method ? [{ label: <MethodTag method={formData.method} />, id: formData.method }] : []}
                onChange={({ value }) => setFormData({ ...formData, method: value[0]?.id })}
                placeholder="Select method"
              />
            </FormControl>

            <FormControl label="Path" caption="URL path for this endpoint">
              <Input
                value={formData.path}
                onChange={e => setFormData({ ...formData, path: e.target.value })}
                placeholder="/api/resource/{id}"
              />
            </FormControl>
          </div>

          <div className={css({
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem'
          })}>
            <Button kind={ButtonKind.tertiary} onClick={() => store.setSelectedEndpoint(null)}>
              Cancel
            </Button>
            <Button type="submit">
              {formData.id ? 'Update' : 'Create'}
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
}
